import { Intro } from "components/commons";
import { StationContext } from "contexts";
import { useExport } from "hooks";
import React, { useContext } from "react";
import RedeemHistoryFilter from "./redeem-history-filter";
import { redeemHistoryState } from "./redeem-history-filter.state";
import { getTransactionHistoryRedeemPoints, generateStationReportLoyalty } from "apis";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { mapDataToList, mapFilterToRequest } from "./redeem-history.mapper";
import { redeemHistoryColumns } from "./redeem-history-columns";
import { SuccessModal } from "components/modals";

const RedeemHistoryModule = ({ title }) => {
  const { station } = useContext(StationContext);
  const { stationId } = station;
  const { filter, search, table } = useDataTable({
    api: { api: getTransactionHistoryRedeemPoints, params: { stationId } },
    filter: { initialState: redeemHistoryState(), mapper: mapFilterToRequest },
    table: {
      key: "conversionHistory",
      mapper: (conversionHistory) => mapDataToList({ conversionHistory }),
      columns: redeemHistoryColumns,
    },
  });

  const exports = useExport({
    api: generateStationReportLoyalty,
    reportType: "vip-redeem-points",
    hasModal: true,
    mappedFilterState: {
      ...filter?.mappedFilterState,
      searchKey: search?.searchKey,
      stationId,
    },
  });

  return (
    <div>
      <div>
        <Intro />
      </div>
      <RedeemHistoryFilter {...filter} {...search} {...exports} />
      <DataTableV2 {...table} paginationV2={true} />
      <SuccessModal {...exports?.successModalComponent} />
    </div>
  );
};

export default RedeemHistoryModule;
